module.exports = __webpack_public_path__ + "img/banner.bddae1a4.png";